/**
 * ONE PACKAGE PER BOOKING (SWP-P-14).
 *
 * The package list let a customer select several packages, and every total —
 * the service step's footer, the time step's, the confirmation's — summed them
 * all. But a booking carries ONE package: the payload sends `package` (the
 * first) and the server writes one PACKAGE line. Two packages at 400 and 300
 * showed 630 after a 10% campaign; the booking was written at 360 and the
 * second package's services were never scheduled.
 *
 * The rule lives here, once: choosing a package replaces the one already
 * chosen (tapping it again removes it), and every reader of the cart counts
 * the package the booking can carry — so what is shown is what is booked, even
 * when a cart arrives from elsewhere (book-again, a deep link) with more.
 */
export const PACKAGES_PER_BOOKING = 1;

/** The packages a booking can carry, from whatever the cart holds. */
export function bookablePackages(packages) {
  return (Array.isArray(packages) ? packages : []).slice(0, PACKAGES_PER_BOOKING);
}

const idOf = (pkg) => String(pkg?._id ?? pkg?.id ?? '');

/** The cart after tapping `pkg`: removed if chosen, otherwise the only package. */
export function withPackageToggled(current, pkg) {
  const list = Array.isArray(current) ? current : [];
  if (list.some((x) => idOf(x) === idOf(pkg))) return list.filter((x) => idOf(x) !== idOf(pkg));
  return [pkg];
}
